// src/screens/sales/executor/components/details/Details.tsx

import React from 'react'
import { ExecutorInterface } from '../../../../../common/types/interfaces'
import classes from './Details.module.sass'

type Props = {
  el?: ExecutorInterface
}

export const Details = ({ el }: Props) => {
  if (!el) return null

  return (
    <div className={classes.container}>
      <div className={classes.title}>Детали исполнителя</div>
      <div className={classes.name}>{el.name}</div>
      <div className={classes.phone}>
        <a href={`tel:${el.phone_number}`}>{el.phone_number}</a>
      </div>
      {el.position && <div className={classes.position}>{el.position}</div>}

      <div className={classes.section}>
        <div className={classes.sectionTitle}>Роли и статус</div>
        <div className={classes.row}>
          <span className={classes.label}>Статус:</span>
          <span className={el.isActive ? classes.active : classes.inactive}>
            {el.isActive ? 'Активен' : 'Не активен'}
          </span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Перевозчик:</span>
          <span className={classes.value}>{el.isDriver ? '✅ Да' : '❌ Нет'}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Обслуживает клиентов:</span>
          <span className={classes.value}>{el.canServe ? '✅ Да' : '❌ Нет'}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Трекинг геолокации:</span>
          <span className={classes.value}>{el.trackLocation ? '✅ Да' : '❌ Нет'}</span>
        </div>
      </div>

      {el.motivation && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Мотивация</div>
          <div className={classes.row}>
            <span className={classes.label}>ID:</span>
            <span className={classes.value}>{el.motivation.id}</span>
          </div>
          <div className={classes.row}>
            <span className={classes.label}>Название:</span>
            <span className={classes.value}>{el.motivation.name}</span>
          </div>
          {el.motivation.description && (
            <div className={classes.row}>
              <span className={classes.label}>Описание:</span>
              <span className={classes.value}>{el.motivation.description}</span>
            </div>
          )}
        </div>
      )}

      {el.stores && el.stores.length > 0 && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Точки ({el.stores.length})</div>
          {el.stores.map((store) => (
            <div key={store.storeId} className={classes.row}>
              <span className={classes.label}>Точка {store.storeId}:</span>
              <span className={classes.value}>{store.store?.name}</span>
            </div>
          ))}
        </div>
      )}

      {el.user && (
        <div className={classes.section}>
          <div className={classes.sectionTitle}>Пользователь</div>
          <div className={classes.row}>
            <span className={classes.label}>ID:</span>
            <span className={classes.value}>{el.user.id}</span>
          </div>
          {el.user.email && (
            <div className={classes.row}>
              <span className={classes.label}>Email:</span>
              <span className={classes.value}>{el.user.email}</span>
            </div>
          )}
          {el.user.phone_number && (
            <div className={classes.row}>
              <span className={classes.label}>Телефон:</span>
              <span className={classes.value}>{el.user.phone_number}</span>
            </div>
          )}
        </div>
      )}

      <div className={classes.section}>
        <div className={classes.sectionTitle}>Системная информация</div>
        <div className={classes.row}>
          <span className={classes.label}>ID исполнителя:</span>
          <span className={classes.value}>{el.id}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>UUID:</span>
          <span className={classes.value}>{el.uuid?.substring(0, 8)}...</span>
        </div>
        {el.createdAt && (
          <div className={classes.row}>
            <span className={classes.label}>Создан:</span>
            <span className={classes.value}>{new Date(el.createdAt).toLocaleString()}</span>
          </div>
        )}
        {el.updatedAt && (
          <div className={classes.row}>
            <span className={classes.label}>Обновлён:</span>
            <span className={classes.value}>{new Date(el.updatedAt).toLocaleString()}</span>
          </div>
        )}
      </div>
    </div>
  )
}
